import React, { useState, useEffect } from 'react';
import {
    TableHead,
    TableBody,
    TablePagination,
    TextField,
    Grid,
    Container,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { GetCookieInfo } from '../../../logic/CookieManager';
import {
    StyledButtonOrange,
    StyledButtonContainer,
    StyledTableCell,
    StyledTableHeadRow,
    StyledTable, StyledTableBodyRow, StyledTableCellHeader
} from "../../../styles/MyStyles";
import {GetLookupValueName, UpsertLookup} from "../../../logic/LookupHelper";

const OwnBankAccountsPage = () => {
    const [accounts, setAccounts] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchAccounts = async () => {
            try {
                const tokenCookie = GetCookieInfo('nplt');
                const response = await fetch(
                    `${process.env.REACT_APP_BANK_ACCOUNTS_URL}/${process.env.REACT_APP_NEWCENT_CONTACT_ID}`,
                    {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                });
                if (response.ok) {
                    const data = await response.json();
                    setAccounts(data.data);
                    if (data.data) {
                        UpsertLookup('ownBankAccounts', data.data);
                    }
                } else {
                    console.log('Fetch Own Bank Accounts failed.');
                }
            } catch (error) {
                console.log('An error occurred:', error);
            }
        };
        fetchAccounts();
    }, []);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchQueryChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const editAccount = (accountId) => {
        navigate(`edit/${accountId}`);
    };

    const createAccount = () => {
        navigate(`edit/`);
    };

    // Filter the clients based on the search query
    const filteredAccounts = accounts ? accounts.filter(
        (account) =>
            account.iban.toLowerCase().includes(searchQuery.toLowerCase())
    ) : [];

    // Calculate pagination values
    const totalEntities = filteredAccounts.length;
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const paginatedEntities = filteredAccounts.slice(startIndex, endIndex);

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                    <TextField
                        label="Search"
                        value={searchQuery}
                        onChange={handleSearchQueryChange}
                        margin="normal"
                        size="small"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={9} sx={{ textAlign: 'right' }}>
                    <StyledButtonContainer>
                        <StyledButtonOrange variant="contained" onClick={createAccount} margin="normal">
                            New
                        </StyledButtonOrange>
                    </StyledButtonContainer>
                </Grid>
                <Grid item xs={12}>
                    <StyledTable>
                        <TableHead>
                            <StyledTableHeadRow>
                                <StyledTableCellHeader columncount={3}>Bank</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={3}>Asset</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={3}>Iban</StyledTableCellHeader>
                            </StyledTableHeadRow>
                        </TableHead>
                        <TableBody>
                            {paginatedEntities && paginatedEntities.map((bankAccount) => (
                                <StyledTableBodyRow key={bankAccount.id}
                                                    onClick={() => editAccount(bankAccount.id)}>
                                    <StyledTableCell>{GetLookupValueName('bank', bankAccount.bankId)}</StyledTableCell>
                                    <StyledTableCell>{GetLookupValueName('asset', bankAccount.assetId)}</StyledTableCell>
                                    <StyledTableCell>{bankAccount.iban}</StyledTableCell>
                                </StyledTableBodyRow>
                            ))}
                        </TableBody>
                    </StyledTable>
                </Grid>
                <Grid item xs={12} sx={{ textAlign: 'left' }}>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 20, 50]}
                        component="div"
                        count={totalEntities}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Grid>
            </Grid>
        </Container>
    );
};

export default OwnBankAccountsPage;
